import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../messages";
import toastr from "toastr";
import positionHistoryServices from "./positionHistoryServices";

toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: false,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "5000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
};

export const getPositionHistory = filters => async (dispatch) => {
    try {
        dispatch({
            type: actions.LOADER_POSITIONHISTORY,
            payload: true,
        });
        let resp = await positionHistoryServices.getPositionHistory(filters); 
        
        dispatch({
            type: actions.GET_POSITIONHISTORY,
            payload: filters.filter !==""? resp.data : {data:"",count:0},
        });
        dispatch({
            type: actions.POSITIONHISTORY_FAIL,
            payload: null,
        });
    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data.mensaje;
                        break;
                    case 404:
                        if (ex.response.data && ex.response.data.mensaje) {
                            message = ex.response.data.mensaje;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    case 403:
                        if (ex.response.data && ex.response.data.detail) {
                            message = ex.response.data.detail;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    default:
                        message = messages.errorMessage;
                        break;
                }
            } else {
                message = messages.networkError;
            }
        } else {
            message = messages.applicationError
        }
        dispatch({
            type: actions.POSITIONHISTORY_FAIL,
            payload: message
        })
    } finally {
        dispatch({
            type: actions.LOADER_POSITIONHISTORY,
            payload: false,
        });
    }
}






